import type * as React from 'react';
import styled from 'styled-components';

const FieldContainer = styled.p`
  font-size: 10px;
  line-height: 13px;
  white-space: pre-line;
  margin-top: 0;
  margin-bottom: 0;

  &:empty {
    margin-top: 6px;
  }
`;

type TemplateAboutMeProps = {
  aboutMe: string;
  className?: string;
};

export const TemplateAboutMe: React.FC<TemplateAboutMeProps> = ({
  aboutMe,
  className,
}) => <FieldContainer className={className}>{aboutMe}</FieldContainer>;
